import React from "react";
import { Download, Funnel, Search } from "lucide-react";
import { cn } from "../../lib/utils";

export default function SearchBar({
  placeholder = "Pesquisar...",
  value,
  onChange,
  onFilter,
  showFilter = false,
  showDownload = false,
  className = "",
}) {
  return (
    <div className={cn("flex w-full items-center gap-2", className)}>
      <div className="relative flex-1">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className="h-10 w-full rounded-lg border border-input bg-background pl-9 pr-3 text-sm placeholder:text-muted-foreground transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        />
      </div>

      {showFilter && (
        <button
          type="button"
          onClick={onFilter}
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-input bg-background hover:bg-accent"
          title="Filtros"
        >
          <Funnel className="h-4 w-4" />
        </button>
      )}

      {showDownload && (
        <button
          type="button"
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-input bg-background hover:bg-accent"
          title="Download"
        >
          <Download className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
